//@flow
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import Checklist from 'dibs-icons/exports/Checklist';
import ServicePerson from 'dibs-icons/exports/ServicePerson';
import StarCircle from 'dibs-icons/exports/StarCircle';

import { BarHeader } from 'dibs-elements/exports/BarHeader';

import stepContactsStyles from './styles/FormStepContacts.scss';

import { MatchmakerIcon } from 'dibs-matchmaker-icon/exports/MatchmakerIcon';

const instructionTitle = (
    <FormattedMessage
        id="abt.matchmaker.howItWorks.instructionTitle"
        defaultMessage="How It Works"
    />
);

export const HowItWorksComponent = () => (
    <Fragment>
        <BarHeader title={instructionTitle} size="large" />
        <div className={stepContactsStyles.howItWorks}>
            <div className={stepContactsStyles.howItWorksInner}>
                <div className={stepContactsStyles.icon}>
                    <Checklist />
                </div>
                <div className={stepContactsStyles.preferenceKeywords}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference1.keyWords"
                        defaultMessage="Outline Your Project"
                    />
                </div>
                <div className={stepContactsStyles.preferenceDescription}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference1.description"
                        defaultMessage="Let us know your project and style preferences."
                    />
                </div>
            </div>
            <div className={stepContactsStyles.howItWorksInner}>
                <div className={stepContactsStyles.icon}>
                    <ServicePerson />
                </div>
                <div className={stepContactsStyles.preferenceKeywords}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference2.keyWords"
                        defaultMessage="Discuss Needs"
                    />
                </div>
                <div className={stepContactsStyles.preferenceDescription}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference2.description"
                        defaultMessage="A member from our concierge team will call you to learn more about your project."
                    />
                </div>
            </div>
        </div>

        <div className={stepContactsStyles.howItWorks}>
            <div className={stepContactsStyles.howItWorksInner}>
                <div className={stepContactsStyles.icon}>
                    <StarCircle />
                </div>
                <div className={stepContactsStyles.preferenceKeywords}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference3.keyWords"
                        defaultMessage="Receive a Personalized List"
                    />
                </div>
                <div className={stepContactsStyles.preferenceDescription}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference3.description"
                        defaultMessage="They'll curate a list of award-winning designers for your consideration."
                    />
                </div>
            </div>
            <div className={stepContactsStyles.howItWorksInner}>
                <div className={stepContactsStyles.icon}>
                    <MatchmakerIcon
                        wrapperClass={stepContactsStyles.matchmakerIcon}
                        dividerClass={stepContactsStyles.matchmakerDivider}
                        personClass={stepContactsStyles.person}
                        professionalClass={stepContactsStyles.professional}
                    />
                </div>
                <div className={stepContactsStyles.preferenceKeywords}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference4.keyWords"
                        defaultMessage="Select a Designer"
                    />
                </div>
                <div className={stepContactsStyles.preferenceDescription}>
                    <FormattedMessage
                        id="abt.matchmaker.howItWorks.preference4.description"
                        defaultMessage="Review the list and reach out to the designer you're most interested in."
                    />
                </div>
            </div>
        </div>
    </Fragment>
);

export const HowItWorks = HowItWorksComponent;
